// Union type of all possible messages

import {
  ContractDocumentsEmailSentMessage,
  ContractDocumentsErrorMessage,
  ContractDocumentsRecreatedMessage,
  ContractDocumentsUpdatedMessage,
  DuplicateLoginDetectedMessage,
  FinalizeErrorMessage,
  OfferFinalizationStartedMessage,
  OfferFinalizeProgressMessage,
  OfferUpdatedMessage,
  SapContractCreatedMessage,
  SapContractErrorMessage,
  SessionChangedMessage,
  UpgradeModeOnMessage,
  VersionMessage
} from 'app/app/api/sse/messages'

export type SSEMessageType =
  | FinalizeErrorMessage
  | OfferUpdatedMessage
  | UpgradeModeOnMessage
  | VersionMessage
  | OfferFinalizationStartedMessage
  | SapContractCreatedMessage
  | SapContractErrorMessage
  | ContractDocumentsUpdatedMessage
  | ContractDocumentsRecreatedMessage
  | ContractDocumentsEmailSentMessage
  | ContractDocumentsErrorMessage
  | OfferFinalizeProgressMessage
  | SessionChangedMessage
  | DuplicateLoginDetectedMessage

export enum SSE_MESSAGE_TYPES_ENUM {
  FINALIZE_ERROR = 'finalize-error',
  OFFER_UPDATED = 'offer-updated',
  UPGRADE_MODE_ON = 'upgrade-mode-on',
  VERSION = 'version',
  OFFER_FINALIZATION_STARTED = 'offer-finalization-started',
  SAP_CONTRACT_CREATED = 'sap-contract-created',
  SAP_CONTRACT_ERROR = 'sap-contract-error',
  CONTRACT_DOCUMENTS_UPDATED = 'contract-documents-updated',
  CONTRACT_DOCUMENTS_RECREATED = 'contract-documents-recreated',
  CONTRACT_DOCUMENTS_EMAIL_SENT = 'contract-documents-email-sent',
  CONTRACT_DOCUMENTS_ERROR = 'contract-documents-error',
  OFFER_FINALIZE_PROGRESS = 'offer-finalize-progress',
  SESSION_CHANGED = 'session-changed',
  DUPLICATE_LOGIN_DETECTED = 'duplicate-login-detected'
}
